<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row>
            <b-col cols="12">
                <FormInput type="text" label="Nombre" name="name" id="name" rules="required" v-model="categoria.name" />
            </b-col>
            <b-col cols="12" class="mt-2">
                <FormInput type="text" label="Descripción" name="description" id="description" rules="required" v-model="categoria.description" />
            </b-col>
            <b-col cols="12" class="text-right mt-3">
                <Button type="submit" name="button" :disabled="loading">
                    CONTINUAR
                </Button>
            </b-col>
        </b-row>
    </ValidationObserver>
</template>

<script>
export default {
    props: ['categoria', 'loading'],
    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.categoria.teatro_id = this.teatro.id;
                this.$emit('terminado');
            }
        }
    },
    computed: {
        teatro() {
            return this.$store.getters.getTeatro;
        }
    }
}
</script>